import { createColumnHelper } from '@tanstack/react-table';
import { LocalizedDateTimeFromUtc } from '@mews-commander/ui';
import { LocalizedCurrencyValue, lt } from '@mews/framework';
import { Stack, Table, TableProvider, Typography, useTableState } from '@optimus-web/core';
import { Transaction } from '../types';

const helper = createColumnHelper<Transaction>();

const columns = [
    helper.accessor('number', {
        header: () => lt('Number'),
    }),
    helper.accessor('customerName', {
        header: () => lt('Customer'),
    }),
    helper.accessor('createdUtc', {
        header: () => lt('Created'),
        cell: ({ getValue, row }) => (
            <Stack vertical>
                <LocalizedDateTimeFromUtc utcString={getValue()} />
                <Typography textStyle="bodyMedium" as="div" variant="tertiary">
                    {row.original.creatorName}
                </Typography>
            </Stack>
        ),
    }),
    helper.accessor('billName', {
        header: () => lt('Bill'),
    }),
    helper.accessor('notes', {
        header: () => lt('Notes'),
    }),
    helper.accessor('amount', {
        header: () => lt('Amount'),
        cell: ({ getValue }) => (
            <LocalizedCurrencyValue value={{ value: getValue().value, currency: getValue().currency }} />
        ),
    }),
];

interface Props {
    cashierId: string;
    shiftId?: string;
}

const transactions = [
    {
        createdUtc: '2024-11-29T13:16:40.7895293',
        number: 1,
        customerName: 'John Doe',
        amount: {
            value: 10.5,
            currency: 'EUR',
        },
        billName: 'Bill name',
        notes: 'string',
        creatorName: 'James Doe',
    },
] satisfies Transaction[];

// TODO remove
// eslint-disable-next-line @typescript-eslint/no-unused-vars
export const ShiftTransactionsTable = ({ cashierId, shiftId }: Props) => {
    const [tableState, setTableState] = useTableState<Transaction>({
        pagination: {
            show: true,
        },
    });

    return (
        <TableProvider columns={columns} state={tableState} onStateChange={setTableState}>
            <Table
                data-test-id="shift-overview-table"
                // loading={isFetching} TODO add
                uniqueRowId="number"
                data={transactions}
                amountOfRows={transactions.length}
            />
        </TableProvider>
    );
};
